import logo from './logo.svg';
import './App.css';
import StatsShowcase from './components/CountupWrapper/Count';
import ServicesShowcase from './components/Services/Services';
import AboutMe from './components/me/Me';
import HeroSection from './screens/FirstScreen';
import SecondScreen from './screens/SecondScreen';
import ThirdScreen from './screens/ThirdScreen';
import ForthScreen from './screens/ForthScreen';
import ByMe from './components/ByMe/ByMe';
import FifthScreen from './screens/FifthScreen';

function App() {
  return <>
  <HeroSection/>
  <SecondScreen/>


<AboutMe/>
<ThirdScreen/>
<FifthScreen/>
<ServicesShowcase/>

<ForthScreen/>
<ByMe/>
  </>
}

export default App;
